/* eslint-disable prefer-destructuring */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { useCallback, useEffect, useState } from 'react'
import useTranslation from 'next-translate/useTranslation'
import { useToast } from 'tennders-common/hooks/useToast'
import { apiGet, getToken } from 'tennders-stracture/libs/api'
import { cleanObject } from 'tennders-stracture/libs/utils'
import { dispatchGenerateOrderDoc } from 'tennders-common/stores/prompt/action'
import { useDispatch, useSelector } from 'react-redux'
import axios from 'axios'
import useTransactions from 'tennders-transactions/hooks/useTransactions'
import useValidation from 'tennders-common/hooks/useValidation'
import * as yup from 'yup'
import moment from 'moment/moment'
import { downloadFile } from 'tennders-stracture/libs/download'

const useOrderDocumentForm = () => {
  const { t } = useTranslation()
  const [loading, setloading] = useState(false)
  const [copy, setcopy] = useState(true)
  const [oplog, setoplog] = useState(false)
  const [submitting, setsubmitting] = useState(false)
  const [isSubmitted, setIsSubmitted] = useState(false)
  const generateDoc = useSelector((state) => state.prompt.generateDoc)
  const dispatch = useDispatch()
  const { requiredField, requiredFieldObject, validate } = useValidation()
  const close = () => dispatch(dispatchGenerateOrderDoc(false))
  const [form, setform] = useState({
    pickupRoute: {},
    deliveryRoute: {},
    pickupStops: [],
    deliveryStops: [],
    orderDate: new Date(),
    isPalletsInterchange: false,
    isAdr: false,
    shipmentItems: []
  })

  const generalRules = {
    typeOfGoods: !form.shipmentItems?.length && requiredField(),
    companyName: requiredField(),
    companyContact: requiredField(),
    companyEmail: requiredField(),
    companyAddress: requiredField(),
    companyNif: requiredField(),
    truckType: requiredField(),
    plateNumber: requiredField(),
    trailerNumber: requiredField(),
    price: requiredField(),
    paymentTerm: requiredField(),
    noOfPallets: !form.shipmentItems?.length && requiredField(),
    orderNumber: requiredField(),
    orderDate: requiredField(),
    weight: !form.shipmentItems?.length && requiredField(),
    isAdr: requiredField(),
    isPalletsInterchange: requiredField()
  }
  const pickupRules = {
    company: requiredField(),
    location: requiredFieldObject(),
    date: requiredField(yup.array),
    address: requiredField()
  }
  const deliveryRules = {
    company: requiredField(),
    location: requiredFieldObject(),
    date: requiredField(yup.array),
    address: requiredField()
  }
  const [errors, setErrors] = useState({})
  const [pickupStops, setPickupStops] = useState([])
  const [deliveryStops, setDeliveryStops] = useState([])
  const { toastSuccess, toastError } = useToast()
  const { refreshTransaction } = useTransactions()

  const onChange = (k, v, childKey) => {
    setform({ ...form, [k]: v })
    if (childKey && isSubmitted && errors[k]) {
      const _errors = { ...errors }
      _errors[k][childKey] = false
      setErrors(_errors)
    } else {
      setErrors({ ...errors, [k]: false })
    }
  }

  const onChangeMultiple = useCallback((data) => {
    if (data) {
      const _errors = {}
      const _form = {}
      Object.keys(data).forEach(x => {
        _errors[x] = false
        _form[x] = data[x]
      })
      setErrors(prevState => ({ ...prevState, ..._errors }))
      setform(prevState => ({ ...prevState, ..._form }))
    }
  }, [form])

  const generateOrderDoc = async (axiosUrl, fromScratch) => {
    let _errors = {}
    let _response
    const { saveToDeviceAfter, ...rest } = form
    const params = { ...rest }
    if (pickupStops && pickupStops.length > 0) {
      params.pickupStops = pickupStops
    }
    if (deliveryStops && deliveryStops.length > 0) {
      params.deliveryStops = deliveryStops
    }
    const generalRulesValidated = await validate(form, generalRules)
    if (generalRulesValidated.validated !== true) {
      _errors = { ...generalRulesValidated.errors }
    }
    const pickupRulesValidated = await validate({
      ...form?.pickupRoute,
      company: form.pickupRoute?.details?.company
    }, pickupRules)
    if (pickupRulesValidated.validated !== true) {
      _errors = { ..._errors, pickupRoute: { ...pickupRulesValidated.errors } }
    }
    const deliveryRulesValidated = await validate({
      ...form?.deliveryRoute,
      company: form.deliveryRoute?.details?.company
    }, deliveryRules)
    if (deliveryRulesValidated.validated !== true) {
      _errors = { ..._errors, deliveryRoute: { ...deliveryRulesValidated.errors } }
    }

    const pickupStopsValidations = await Promise.all(pickupStops.map((pickupStop) => validate({
      ...pickupStop,
      company: pickupStop?.details?.company
    }, pickupRules)))
    const deliveryStopsValidations = await Promise.all(deliveryStops.map((deliveryStop) => validate({
      ...deliveryStop,
      company: deliveryStop?.details?.company
    }, deliveryRules)))

    pickupStopsValidations.forEach((validation, i) => {
      if (validation.validated === false) {
        _errors['pickupStops[' + i + ']'] = validation.errors
      }
    })

    deliveryStopsValidations.forEach((validation, i) => {
      if (validation.validated === false) {
        _errors['deliveryStops[' + i + ']'] = validation.errors
      }
    })

    if (_errors && Object.keys(_errors).length > 0) {
      setErrors(_errors)
      toastError(t('addLoad:checkErrors'))
      if (fromScratch) {
        window.scrollTo({ top: 100, behavior: 'smooth' })
      } else {
        const elementModal = document.getElementsByClassName('modal')
        if (elementModal?.length) {
          elementModal[0].scrollIntoView({ behavior: 'smooth' })
        }
      }
      return null
    }
    const headers = { Authorization: `Bearer ${getToken()}` }
    params.tzo = (new Date().getTimezoneOffset()).toString()
    await axios
      .post(process.env.API_URL + axiosUrl, params, { headers, responseType: 'blob' })
      .then((response) => {
        _response = response
      })
      .catch((errors) => {
        _errors = errors?.response?.data?.errors || errors?.response?.data?.error
      })
    return {
      response: _response,
      errors: _errors,
      saveToDevice: saveToDeviceAfter
    }
  }

  const handleSubmit = async (fromScratch = null, next = null) => {
    setsubmitting(true)
    setIsSubmitted(true)
    const response = await generateOrderDoc(!generateDoc?.transaction.id ? '/documents/generate-order-doc' : `/documents/${generateDoc?.transaction.id}/generate-order-doc`, fromScratch)
    if (!response) {
      setsubmitting(false)
      return null
    }
    if (response?.errors && Object.keys(response.errors)?.length > 0) {
      setErrors(response.errors)
      toastError(t('document:fillRequired'))
    } else if (response?.error) {
      toastError(t('variables:SOMETHING_WENT_WRONG'))
    } else {
      toastSuccess(t('document:savedSuccessfully'))
      if (response.saveToDevice) {
        const res = response.response
        const date = moment().format('DD/MM/YYYY hh:mm')
        let fileName = `order_confirmation_doc-${date}.pdf`
        if (typeof res?.headers['content-disposition'] !== 'undefined') {
          fileName = res.headers['content-disposition'].split('-')[1]
        }
        downloadFile(res.data, fileName)
      }
      close()
      setTimeout(() => {
        refreshTransaction(generateDoc?.transaction.id)
      }, 100)
      setTimeout(() => {
        if (next) {
          next()
        }
      }, 3000)
    }
    setsubmitting(false)
    return null
  }

  const addPickupStop = () => {
    const stop = { identifier: new Date().getTime() }
    setPickupStops([...pickupStops, stop])
  }

  const addDeliveryStop = () => {
    const stop = { identifier: new Date().getTime() }
    setDeliveryStops([...deliveryStops, stop])
  }

  const removePickupStop = (identifier) => {
    setPickupStops([...pickupStops].filter((stop) => stop.identifier !== identifier))
  }

  const removeDeliveryStop = (identifier) => {
    setDeliveryStops([...deliveryStops].filter((stop) => stop.identifier !== identifier))
  }

  const fetchLog = async (id) => {
    if (id) {
      setloading(true)
      const response = await apiGet(`documents/${id}/order-doc`)
      setoplog(response)
      setloading(false)
    }
  }

  const getMinPickupDate = (index) => {
    let minPickupDate = form.pickupRoute && form.pickupRoute.date && form.pickupRoute.date[0]
    if (index === 0) {
      return minPickupDate
    }
    for (let i = 0; i < pickupStops.length && i < index; i += 1) {
      if (pickupStops[i] && pickupStops[i].date) {
        minPickupDate = pickupStops[i].date[0]
      }
    }
    return minPickupDate
  }

  const getMinDeliveryRouteDate = () => {
    let minDate = form.pickupRoute && form.pickupRoute.date && (form.pickupRoute.date[1] || form.pickupRoute.date[0])
    for (let i = 0; i < pickupStops.length; i += 1) {
      if (pickupStops[i] && pickupStops[i].date) {
        if (minDate < pickupStops[i].date[0]) {
          minDate = pickupStops[i].date[0]
        } else if (minDate < pickupStops[i].date[1]) {
          minDate = pickupStops[i].date[1]
        }
      }
    }
    return minDate
  }

  const getMinDeliveryDate = (index) => {
    let minDate = form.deliveryRoute && form.deliveryRoute.date && form.deliveryRoute.date[0]
    if (index === 0) {
      return minDate
    }
    for (let i = 0; i < deliveryStops.length && i < index; i += 1) {
      if (deliveryStops[i] && deliveryStops[i].date) {
        minDate = deliveryStops[i].date[0]
      }
    }
    return minDate
  }

  useEffect(() => {
    if (!copy) {
      setform({
        ...cleanObject(form),
        pickupRoute: {},
        deliveryRoute: {},
        pickupStops: [],
        deliveryStops: [],
        orderDate: new Date()
      })
      setPickupStops([])
      setDeliveryStops([])
    }
  }, [copy])

  useEffect(() => {
    if (oplog && oplog.pickupRoute && copy) {
      const f = { orderDate: new Date(), ...oplog }
      setform(f)
      setErrors({})
      if (oplog.pickupStops) {
        setPickupStops([...oplog.pickupStops])
      }
      if (oplog.deliveryStops) {
        setDeliveryStops([...oplog.deliveryStops])
      }
    }
  }, [oplog, copy])

  useEffect(() => {
    if (generateDoc) {
      const { transaction } = generateDoc
      fetchLog(transaction.id)
    }
  }, [generateDoc])

  return {
    handleSubmit,
    setform,
    form,
    errors,
    submitting,
    onChange,
    generateDoc,
    close,
    loading,
    setcopy,
    copy,
    pickupStops,
    removePickupStop,
    getMinPickupDate,
    addPickupStop,
    getMinDeliveryRouteDate,
    setPickupStops,
    deliveryStops,
    removeDeliveryStop,
    getMinDeliveryDate,
    setDeliveryStops,
    addDeliveryStop,
    onChangeMultiple
  }
}

export default useOrderDocumentForm
